/* eslint-disable */
import { useState } from "react";
import "./copImagesComponent.scss";
import { nanoid } from "@reduxjs/toolkit";
import Polygon from "components/common/icons/downArrow";
import { useSelector } from "react-redux";

const COPImagesComponent = (props) => {
  const { width, graphData, heading, keys, tooltips } = props;

  const [selectedIndex, setSelectedIndex] = useState(0);

  const mode = useSelector(state => state.theme.mode)

  const handleIndexing = (command) => {
    if (command === "increase") {
      if (selectedIndex < keys.length - 1) {
        setSelectedIndex(selectedIndex + 1);
      }
    }
    if (command === "decrease") {
      if (selectedIndex !== 0) {
        setSelectedIndex(selectedIndex - 1);
      }
    }
  };

  return (
    <div className="cop_images_container">
      <div className="cop_images_headings">
        <h3>{heading}</h3>
      </div>
      <div className="cop_images_image">
        <div
          className={`image_arrows ${
            selectedIndex === 0 ? "image_arrows_disabled" : ""
          }`}
          onClick={() => handleIndexing("decrease")}
        >
          <Polygon
            direction={"left"}
            size="20"
            color={selectedIndex === 0 ? "grey" : "white"}
          />
        </div>
        {/* <img src={graphData[keys[selectedIndex]+`${mode === "dark" ? "" : "_light"}`]} /> */}
        <img
          src={
            graphData[
              keys[selectedIndex] +
                (mode === "light" && graphData[keys[selectedIndex] + "_light"]
                  ? "_light"
                  : "")
            ]
          }
        />
        <div
          className={`image_arrows ${
            selectedIndex < keys.length - 1 ? "" : "image_arrows_disabled"
          }`}
          onClick={() => handleIndexing("increase")}
        >
          <Polygon
            direction={"right"}
            size="20"
            color={selectedIndex < keys.length - 1 ? "white" : "grey"}
          />
        </div>
      </div>
      {heading?.length > 0 ? (
        <div className="cop_images_controls">
          {keys.map((item, index) => (
            <div
              onClick={() => setSelectedIndex(index)}
              className={`image_control ${
                index == selectedIndex ? "image_control_selected" : ""
              }`}
              key={nanoid()}
            ></div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default COPImagesComponent;
